import { LoaderCircle } from "lucide-react";

export function Spinner() {
    return (
        <div className="flex items-center justify-center w-full">
            <LoaderCircle size={64} className="animate-spin text-primary" />
        </div>
    );
}
